import React from "react";
import SharedDonut from "../../common/DonutChart";
import { getPaletteColor } from "../../../utils/chartTheme";

const ConstructionTypesChart = ({ data, centerValue, centerLabel }) => {
  // Transform the construction type data
  const constructionTypeData =
    data?.map((item, index) => ({
      name: item.constructionType || "Unknown",
      value: item.count || 0,
      totalCost: item.totalCost || 0,
      percentage: item.percentage || "0%",
      color: getPaletteColor(index),
    })) || [];

  return (
    <SharedDonut
      items={constructionTypeData.map((item) => ({
        name: formatTypeName(item.name),
        value: item.value,
        color: item.color,
        detail: `Cost: ${formatCost(item.totalCost)}`,
      }))}
      centerLabel={centerLabel}
    />
  );
};

function formatTypeName(name) {
  const typeMap = {
    new: "New Construction",
    rehab: "Rehabilitation",
    repair: "Repair",
    upgrade: "Upgrade",
    renovation: "Renovation",
  };
  return typeMap[name] || name.charAt(0).toUpperCase() + name.slice(1);
}

function formatCost(cost) {
  if (cost >= 1000000) return `${(cost / 1000000).toFixed(1)}M`;
  if (cost >= 1000) return `${(cost / 1000).toFixed(1)}K`;
  return `${cost.toLocaleString()}`;
}

export default ConstructionTypesChart;
